import { useLangLabels } from "../../../../shared/lang/services/useLangLabels";
import { usePeriod } from "../../../../shared/date";
import { FlexContainer } from "../../../../components/containers";
import VirtualGrid from "../../../../shared/react-table/VirtualGrid/VirtualGrid";
import { useGetSupervisedRevisionChanges } from "../services/revisionChangeServices";
import { useRevisionChangeGridModel } from "../lang/useRevisionChangeGridModel";
import RevisionChangeStatus from "./RevisionChangeStatus";
import RevisionChangeSupervisionForm from "./RevisionChangeSupervisionForm";
import { CarrousellActionInterface } from "../../../../shared/react-table/VirtualGrid/types/VirtualGridTypes";
import { RevisionChangeInterface } from "../types/revisionChangeType";

const SupervisedRevisionChanges = () => {
  const { lang } = useLangLabels();
  const gridModel = useRevisionChangeGridModel();
  const entityName = lang.revisionChange.supervisedRevisionChanges;

  const { period, setPeriod } = usePeriod(7, entityName);

  const { data: revisionChanges, isFetching } = useGetSupervisedRevisionChanges();

  const carrousellComponents: CarrousellActionInterface = [
    {
      icon: "edit",
      popoverTitle: lang.crudActions.update,
      component: (item: RevisionChangeInterface) => (
        <RevisionChangeSupervisionForm item={item} isDataUpdated={!isFetching} />
      ),
    },
  ];

  return (
    <FlexContainer>
      <VirtualGrid
        entityName={entityName}
        gridModel={gridModel}
        items={revisionChanges || []}
        title={entityName}
        carrousellComponents={carrousellComponents}
        period={period}
        periodChange={setPeriod}
        renderOptionColumn={{
          headerName: lang.revisionChange.state,
          renderOption: item => <RevisionChangeStatus item={item} />,
        }}
      />
    </FlexContainer>
  );
};

export default SupervisedRevisionChanges;
